<template>
  <v-dialog v-model="isOpen" max-width="600px">
    <v-card>
      <v-card-title>
        <div>
          <div class="headline">Datos requeridos</div>
        </div>
      </v-card-title>
      <v-card-text class="add-datas">
        <!-- <v-stepper v-model="e1">
                    <v-stepper-header>
                        <v-stepper-step :complete="e1 > 1" step="1">P1</v-stepper-step>

                        <v-divider></v-divider>

                        <v-stepper-step :complete="e1 > 2" step="2">P2</v-stepper-step>

                        <v-divider></v-divider>

                        <v-stepper-step step="3">P3</v-stepper-step>

                        <v-divider></v-divider>

                        <v-stepper-step step="4">P4</v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <v-card
                                class="mb-5"
                                color="white"
                                height="200px">
                                <v-card-text>
                                    <v-container grid-list-md>
                                        <v-layout wrap>
                                            
                                        </v-layout>
                                        
                                    </v-container>
                                </v-card-text>
                            </v-card>
                            <v-btn color="primary" @click.stop="e1 = 2">
                                Continuar
                            </v-btn>
                        </v-stepper-content>

                        <v-stepper-content step="2">
                            <v-card
                                class="mb-5"
                                color="grey lighten-1"
                                height="150px">
                                <v-card-text>
                                    <v-layout wrap>
                                        
                                    </v-layout>
                                </v-card-text>
                            </v-card>

                            <v-btn color="primary" @click.stop="e1 = 3">
                                Continuar
                            </v-btn>

                            <v-btn flat @click="e1 = 2">Atrás</v-btn>
                        </v-stepper-content>

                        <v-stepper-content step="3">
                            <v-card
                                class="mb-5"
                                color="white"
                                height="200px">
                                <v-card-text>
                                    <v-container grid-list-md>
                                        <v-layout wrap>

                                        </v-layout>
                                        
                                    </v-container>
                                </v-card-text>
                            </v-card>

                            <v-btn color="success" @click.stop="e1 = 4">
                                Continuar
                            </v-btn>
                        </v-stepper-content>

                        <v-stepper-content step="4">
                            <v-card
                                class="mb-5"
                                color="white"
                                height="200px">
                                <v-card-text>
                                    <v-container grid-list-md>
                                        <v-layout wrap>
                                            <v-flex xs12>
                                                Fin
                                            </v-flex>
                                        </v-layout>
                                        
                                    </v-container>
                                </v-card-text>
                            </v-card>

                            <v-btn flat @click="e1 = 1">Cerrar</v-btn>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper> -->
        <v-form v-if="data">
          <v-container>
            <v-layout row wrap>
              <template v-if="e1 === 1">
                <v-flex xs12>
                  <v-text-field
                    v-if="!dataEspejo.nombre"
                    v-model="data.nombre"
                    label="Nombre"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-text-field
                    v-if="!dataEspejo.apellido1"
                    v-model="data.apellido1"
                    label="Apellido 1"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-text-field
                    v-if="!dataEspejo.apellido2"
                    v-model="data.apellido2"
                    label="Apellido 2"
                  ></v-text-field>
                </v-flex>
              </template>

              <template v-if="e1 === 2">
                <v-flex xs12>
                  <v-text-field
                    v-if="!dataEspejo.direccion.calle"
                    v-model="data.direccion.calle"
                    label="Dirección"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm3 md3>
                  <v-text-field
                    v-if="!dataEspejo.direccion.cp"
                    v-model="data.direccion.cp"
                    label="C.P."
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm9 md9>
                  <v-text-field
                    v-if="!dataEspejo.direccion.localidad"
                    v-model="data.direccion.localidad"
                    label="Localidad"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-text-field
                    v-if="!dataEspejo.direccion.provincia"
                    v-model="data.direccion.provincia"
                    label="Provincia"
                  ></v-text-field>
                </v-flex>
              </template>

              <template v-if="e1 === 3">
                <v-flex xs12>
                  <v-text-field
                    v-if="!dataEspejo.tlf"
                    v-model="data.tlf"
                    label="Teléfono"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md3>
                  <v-text-field
                    v-if="!dataEspejo.nif"
                    v-model="data.nif"
                    label="NIF"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-text-field
                    v-if="!dataEspejo.fechaNacimiento"
                    v-model="data.fechaNacimiento"
                    label="F. Nacimiento"
                  ></v-text-field>
                </v-flex>
              </template>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.stop="saveData">Continuar</v-btn>
        <v-btn color="blue darken-1" flat @click.native="salir">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["pantalla", "dataModel", "usuario1"],
  data() {
    return {
      isOpen: true,
      e1: 0,
      /* data: [
                'nombre',
                'apellidos',
                'nif',
                'tlf',
                'fechaNacimiento',
                'calle',
                'cp',
                'localidad',
                'provincia'
            ] */
      /* pantalla: [
                ['nombre', 'apellidos'],
                ['calle','cp','localidad','provincia'],
                ['nif','tlf','fechaNacimiento']
            ], */
      data: null,
      dataEspejo: null
    };
  },
  watch: {
    usuario() {
      this.userData();
    }
  },
  created() {
    this.userData();
    this.next();
  },
  methods: {
    checkPantalla(p) {
      if (p < 1) {
        return true;
      }
      const panta = this.pantalla[p - 1];
      let result = false;
      switch (p) {
        case 1:
        case 3:
          for (let index = 0; index < panta.length; index++) {
            const element = panta[index];
            if (!this.dataEspejo[element]) {
              result = true;
            }
          }
          return result;
        case 2:
          for (let index = 0; index < panta.length; index++) {
            const element = panta[index];
            if (!this.dataEspejo.direccion[element]) {
              result = true;
            }
          }
          return result;
        default:
          break;
      }
    },
    userData() {
      this.data = JSON.parse(
        JSON.stringify(Object.assign({}, this.dataModel, this.usuario))
      );
      this.dataEspejo = JSON.parse(JSON.stringify(this.data));
      /* if (this.usuario) {
                this.data = Object.assign({}, this.usuario)
            } */
    },
    next() {
      const totalE = this.pantalla.length - 1;
      // eslint-disable-next-line
            console.log(`TotalE: ${totalE}`)
      this.e1 = totalE >= this.e1 ? this.e1 + 1 : 0;
      if (!this.checkPantalla(this.e1)) {
        this.next();
      }
    },
    saveData() {
      this.$store.dispatch("updateUsuario", this.data);
      this.next();
    },
    salir() {
      this.isOpen = false;
    }
  },
  computed: {
    usuario() {
      return this.$store.getters.getUsuario;
    },
    isChanged() {
      return this.dataEspejo !== this.data; // JSON.stringify(this.dataEspejo) === JSON.stringify(this.data)
    }
  }
};
</script>

<style scoped>
.add-data {
  min-height: 450px;
}
</style>
